export default "__VITE_ASSET__DJn1$jR1__"